module.exports = __webpack_public_path__ + "static/img/fullscreen-image_lets-get_768.b0a15dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/policy-manual-wizard/fullscreen-image_lets-get_768.png
// module id = RDRt
// module chunks = 0